import { render, staticRenderFns } from "./department.vue?vue&type=template&id=6614b5f6&scoped=true&"
import script from "./department.vue?vue&type=script&lang=js&"
export * from "./department.vue?vue&type=script&lang=js&"
import style0 from "./department.vue?vue&type=style&index=0&id=6614b5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6614b5f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6614b5f6')) {
      api.createRecord('6614b5f6', component.options)
    } else {
      api.reload('6614b5f6', component.options)
    }
    module.hot.accept("./department.vue?vue&type=template&id=6614b5f6&scoped=true&", function () {
      api.rerender('6614b5f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/department/department.vue"
export default component.exports